if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
  subscribe(PUB_SUB_EVENTS.variantChange, (event) => {
    const { sectionId, html } = event.data;
    const source = html.getElementById(`ButtonPrice-${sectionId}`);
    const destination = document.getElementById(`ButtonPrice-${sectionId}`);

    if (source && destination) {
      destination.innerHTML = source.innerHTML;
    }
  });
}
